import React from 'react';
import { XIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['La tarea termina en llanto y ya no sabés cómo explicarle de otra forma.', 'Dice "soy malo para las matemáticas" y vos no sabés cómo revertirlo.', 'Lo entiende un día y al siguiente lo olvidó como si nunca lo hubiera visto.'];
  return <section className="py-12 md:py-16 relative overflow-hidden bg-background" data-id="element-262">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-263">
        <FadeIn data-id="element-264">
          <h2 className="font-heading text-2xl md:text-4xl font-extrabold text-center mb-6 text-slate-900 leading-tight" data-id="element-265">
            ¿Hasta cuándo las matemáticas van a seguir siendo{' '}
            <span className="text-coral" data-id="element-266">una batalla en tu casa?</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-267">
          <p className="text-base md:text-lg text-slate-600 text-center mb-8 leading-snug max-w-3xl mx-auto" data-id="element-268">
            Querés ayudarlo. Pero explicás de cabeza, inventás métodos al vuelo,
            corregís sin saber si está bien, y terminás la sesión sin saber si
            aprendió algo o si solo copió.
            <br data-id="element-269" />
            <br data-id="element-270" />
            <strong className="text-slate-900 font-bold" data-id="element-271">
              No es falta de amor ni de esfuerzo. Es falta de un sistema.
            </strong>
          </p>
        </FadeIn>

        <div className="bg-white p-6 md:p-8 rounded-3xl border border-slate-100 shadow-soft-lg" data-id="element-272">
          <ul className="space-y-5" data-id="element-273">
            {points.map((point, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-274">
                <li className="flex items-start gap-4 group" data-id="element-275">
                  <div className="bg-coral/10 p-2 rounded-xl shrink-0 group-hover:bg-coral/20 transition-colors" data-id="element-276">
                    <XIcon className="w-5 h-5 text-coral" data-id="element-277" />
                  </div>
                  <span className="text-base text-slate-700 pt-0.5 leading-snug" data-id="element-278">
                    {point}
                  </span>
                </li>
              </FadeIn>)}
          </ul>
        </div>

        <FadeIn delay={0.8} data-id="element-279">
          <div className="mt-8 text-center" data-id="element-280">
            <p className="text-xl md:text-2xl font-heading font-extrabold text-primary" data-id="element-281">
              ¿Y si la próxima semana las matemáticas dejaran de ser una batalla
              en casa?
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}